<div class="container">
    <div class="card shadow rounded">
        <div class="card-header text-white text-center">
            <h4 class="mb-0" style="font: 500 29px / 4px Roboto, sans-serif;">User Management</h4>
        </div>

        <!-- Tab Navigation -->
        <div class="card-body p-5">
            <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                <li class="nav-item" role="presentation">
                    <a class="nav-link" [ngClass]="{ 'active': selectedTab === 'addUser' }"
                        (click)="selectTab('addUser')" id="pills-add-user-tab" data-toggle="pill" href="#pills-add-user"
                        role="tab">Add New User</a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" [ngClass]="{ 'active': selectedTab === 'userList' }"
                        (click)="selectTab('userList')" id="pills-user-list-tab" data-toggle="pill"
                        href="#pills-user-list" role="tab">User List</a>
                </li>
            </ul>

            <!-- Tab Content -->
            <div class="tab-content" id="pills-tabContent">
                <!-- Add New User Tab -->
                <div class="tab-pane fade" [ngClass]="{ 'show active': selectedTab === 'addUser' }" id="pills-add-user"
                    role="tabpanel">
                    <form [formGroup]="userForm" class="p-5 bg-white shadow rounded" (ngSubmit)="onSubmit()">
                        <div class="form-group">
                            <label for="username">Username</label>
                            <input id="username" type="text" formControlName="username" class="form-control"
                                placeholder="Enter Username" required>
                            <div *ngIf="userForm.get('username')?.invalid && (userForm.get('username')?.touched || submitted)"
                                class="text-danger">
                                <small *ngIf="userForm.get('username')?.errors?.['required']">
                                    Username is required.
                                </small>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="password">Password</label>
                            <input id="password" type="password" formControlName="password" class="form-control"
                                placeholder="Enter Password" required>
                            <div *ngIf="userForm.get('password')?.invalid && (userForm.get('password')?.touched || submitted)"
                                class="text-danger">
                                <small *ngIf="userForm.get('password')?.errors?.['required']">
                                    Password is required.
                                </small>
                                <small *ngIf="userForm.get('password')?.errors?.['pattern']">
                                    Password must be at least 8 characters and include at least one uppercase letter,
                                    one lowercase letter, one number, and one special character.
                                </small>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="mobile">Mobile Number</label>
                            <input id="mobile" type="tel" formControlName="mobile" class="form-control"
                                placeholder="Enter Mobile Number" pattern="^[0-9]{10}$" maxlength="10" minlength="10"
                                required>
                            <div *ngIf="userForm.get('mobile')?.invalid && (userForm.get('mobile')?.touched || submitted)"
                                class="text-danger">
                                <small *ngIf="userForm.get('mobile')?.errors?.['required']">
                                    Mobile number is required.
                                </small>
                                <small *ngIf="userForm.get('mobile')?.errors?.['pattern']">
                                    Mobile number must be exactly 10 digits.
                                </small>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="role">Role</label>
                            <select id="role" formControlName="role" class="form-control">
                                <option value="" disabled>Select a Role</option>
                                <option *ngFor="let role of roles" [value]="role.id">{{ role.name }}</option>
                            </select>
                            <div *ngIf="userForm.get('role')?.invalid && (userForm.get('role')?.touched || submitted)"
                                class="text-danger">
                                <small *ngIf="userForm.get('role')?.errors?.['required']">Role is required.</small>
                            </div>
                        </div>

                        <!-- <div class="form-group">
                            <label for="department">Department</label>
                            <select id="department" formControlName="department" class="form-control">
                                <option value="" disabled>Select a Department</option>
                                <option *ngFor="let dept of departments" [value]="dept.dep_id">{{ dept.dep_name }}
                                </option>
                            </select>
                            <div *ngIf="userForm.get('department')?.invalid && (userForm.get('department')?.touched || submitted)"
                                class="text-danger">
                                <small *ngIf="userForm.get('department')?.errors?.['required']">Department is
                                    required.</small>
                            </div>
                        </div> -->

                        <div class="form-group">
                            <label for="department">Department</label>
                            <ng-multiselect-dropdown [placeholder]="'Select Department'" [data]="departments"
                                [(ngModel)]="selectedDepartments" [settings]="dropdownSettings"
                                formControlName="department">
                            </ng-multiselect-dropdown>

                            <div *ngIf="userForm.get('department')?.invalid && (userForm.get('department')?.touched || submitted)"
                                class="text-danger">
                                <small *ngIf="userForm.get('department')?.errors?.['required']">Department is
                                    required.</small>
                            </div>
                        </div>

                        <button type="submit" class="btn btn-block" style="background-color: #0086c1;color: black;">
                            {{ isEditMode ? 'Update User' : 'Add User' }}
                        </button>

                    </form>
                </div>

                <!-- User List Tab -->
                <div class="tab-pane fade" [ngClass]="{ 'show active': selectedTab === 'userList' }"
                    id="pills-user-list" role="tabpanel">
                    <div class="table-responsive">
                        <table class="table table-hover table-bordered mb-0 text-center">
                            <thead class="text-white" style="background-color: #0086c1;">
                                <tr>
                                    <th>Username</th>
                                    <th>Password</th>
                                    <th>Mobile Number</th>
                                    <th>Role</th>
                                    <th>Department</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let user of users">
                                    <td>{{ user.name }}</td>
                                    <td>{{ user.password }}</td>
                                    <td>{{ user.mobile }}</td>
                                    <td>{{ user.role }}</td>
                                    <td>{{ user.department }}</td>
                                    <td>
                                        <button class="btn btn-sm btn-outline-success mr-2" (click)="updateUser(user)">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-outline-danger"
                                            (click)="deleteUser(user.id)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                                <tr *ngIf="users.length === 0">
                                    <td colspan="5" class="text-muted py-3">No users found</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>